const styles = {
  root: {
    backgroundColor: 'background.default',
    paddingY: 2,
  },

  button: {
    minWidth: 230,
  },

  container: {
    backgroundColor: 'common.white',
    padding: { xs: 0, md: 9 },
    border: 1,
    borderColor: 'background.border',
    textAlign: 'center',
    boxShadow: '0px 16px 80px rgba(92, 92, 92, 0.16)',
  },

  containerMobile: {
    backgroundColor: 'common.white',
    padding: { xs: 0, md: 9 },
    textAlign: 'center',
  },

  title: {
    mb: 3,
    textAlign: { xs: 'left', md: 'left', lg: 'center' },
    '&.MuiTypography-h3': {
      color: 'text.primary',
    },
  },

  description: {
    textAlign: { xs: 'left', md: 'left', lg: 'center' },
    '&.MuiTypography-body1': {
      fontSize: { xs: '14px', sm: '16px' },
      lineHeight: '18px',
      fontWeight: '600',
    },
  },

  note: {
    color: '#666666',
    fontSize: '12px!important',
  },

  item: {
    justifyContent: 'center',
    display: 'flex',
    marginBottom: 2,
    position: 'relative',
    height: 56,
    width: 56,
  },

  dropDown: {
    position: 'relative',
    width: '100%',
  },

  dropDownButton: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer',
    textDecoration: 'underline',
    color: 'text.grey300',
    fontWeight: '600',
  },

  dropDownButtonContainer: {
    textAlign: 'center',
    width: '100%',
  },
  dropDownButtonContainerUp: {
    position: 'relative',
  },
  dropDownButtonContainerDown: {
    position: 'relative',
  },

  rowContainer: {
    mt: 2,
    width: '100%',
  },

  widthPerItemInRowVariant: {
    width: { xs: '25%', md: 56 },
    display: 'flex',
    justifyContent: 'center',
    height: 56,
    position: 'relative',
  },
}

export default styles
